<template>
    <div>
        <guide-form 
            :is-guide-form-sidebar-active.sync="isGuideFormSidebarActive"
            :guide-data="guideData"
            @refetch-data="refetchData"
        />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <v-select
                                id="category_id"
                                class="d-inline-block width-350 mr-1"
                                    v-model="catagoryFilter"
                                    placeholder="Filter By Category"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="title"
                                    :reduce="(option) => option.id"
                                    :options="catagoriesData.map(g => ({title: g.title[currentLocale], id: g.id}))"
                            />
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            /> 
                            <b-button
                                variant="primary"
                                @click="updateGuide()"
                            >
                                <span class="text-nowrap">Add Guide</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table
                v-if="!guides.length"
                :items="guides"
                responsive
                :fields="tableColumns"
                show-empty
                empty-text="No matching records found"
                class="position-relative"
            >
            </b-table>
            <table v-else class="table table-striped">
                <thead>
                    <tr>
                    <th scope="col" v-for="(col, index) in tableColumns" :key="index">
                        {{col.label}}
                    </th>
                    </tr>
                </thead>
            <draggable v-model="guides" tag="tbody" hadle=".handle" @change="updateGuidesOrdering()">
                <tr v-for="(item, index) in guides" :key="index">
                    <th scope="row" class="pl-2">
                        <feather-icon size="24" icon="MenuIcon"/> 
                    </th>
                    <td style="width: 10%;">
                        <b-img
                        :src="`${item.cover_image.path}`"
                        height="110"
                        width="170"
                        class="rounded m-0"
                        />
                    </td>
                    <td style="width: 15%;">
                        <span>{{ item.title[currentLocale] }}</span>
                    </td>
                    <td style="width: 10%; ">
                        {{  item.rating  }}
                       <!-- <b-form-rating
                            id="rating-md-no-border"
                            class="rating-blackground"
                            v-model="item.rating"
                            variant="warning"
                            no-border
                            readonly
                        />-->
                    </td>
                    <td style="width: 10%;">
                        <span>{{ item.category[currentLocale] }}</span>
                    </td>
                    <td style="width: 10%;">
                        <span>
                            {{ item.show_site.map(item => item.name[currentLocale].replace(/<\/?p>/g, '')).join(', \n') }}
                        </span>
                    </td>
                    <td class="pl-2">
                        <b-badge
                        pill
                        :variant="`light-${resolveCatagoryStatusVariant(item.is_active)}`"
                        class="text-capitalize"
                        >
                            {{ resolveCatStatusnameVariant(item.is_active) }} 
                        </b-badge>
                    </td>
                    <td class="pl-2">
                        <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateGuide(item)" variant="outline-success">Edit</b-button>
                        <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                    </td>
                </tr>
            </draggable>
        </table>
        <div class="mx-2 mb-2">
            <b-row>
                <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                    <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                </b-col>
                <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalGuides"
                        :per-page="perPage"
                        first-number
                        last-number
                        class="mb-0 mt-1 mt-sm-0"
                        prev-class="prev-item"
                        next-class="next-item"
                    >
                        <template #prev-text>
                            <feather-icon
                                icon="ChevronLeftIcon"
                                size="18"
                            />
                            </template>
                            <template #next-text>
                            <feather-icon
                                icon="ChevronRightIcon"
                                size="18"
                            />
                        </template>
                    </b-pagination>
                </b-col>
            </b-row>
        </div>
    </b-card>
</div>
</template>

<script>
    import {
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BImg,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox, BImgLazy,
        BFormRating
    } from 'bootstrap-vue'
    import Ripple from 'vue-ripple-directive'
    import vSelect from 'vue-select'
    import draggable from 'vuedraggable'
    // import { FeatherIcon, MenuIcon } from 'vue-feather-icons'
    import store from '@/store'
    import { ref,onUnmounted } from '@vue/composition-api'
    import guideStoreModule from '../guideStoreModule'
    import useGuideList from './useGuideList'
    import GuideForm from './GuideForm.vue'

    export default {
        components:{
            BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
            BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup,
            BFormCheckbox, BImg, BImgLazy, draggable, GuideForm, BFormRating,
            vSelect
        },
        directives:{
            'b-modal': VBModal,
            Ripple
        },
        computed: {
            currentLocale() {
                return  this.$i18n.locale;
            },
        },
        setup(){
            const STORE_MODULE_NAME = 'app-guides';
            if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, guideStoreModule)
            onUnmounted(() => {
                if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
            });

            // const coverImage = (files) => {
            //     console.log('file', files)
            //     for(const file of files){
            //         if(file.is_feature) return file.path
            //     }
            // }

            const {
                isGuideFormSidebarActive,
                guideData,
                refetchData,
                fetchData,
                tableColumns,
                searchQuery,
                guides,
                // t,
                catagoriesData,
                catagoryFilter,
                resolveCatagoryStatusVariant,
                resolveCatStatusnameVariant,
                updateGuide,
                // folders,
                dataMeta,
                refGuideListTable,
                currentPage,
                totalCategories,
                perPage,
                deleteData,
                updateGuidesOrdering,
                totalGuides,
            } = useGuideList()

            fetchData()

            // const titleLang = (data, currentLocale, type) => {
            //     const dataLang = data?.foodLang??[]
            //     return dataLang.find(t => t.lang === currentLocale)?.[type]??''
            // }

            return {
                isGuideFormSidebarActive,
                guideData,
                refetchData,
                fetchData,
                tableColumns,
                searchQuery,
                guides,
                // t,
                catagoriesData,
                catagoryFilter,
                resolveCatagoryStatusVariant,
                resolveCatStatusnameVariant,
                // titleLang,
                updateGuide,
                // folders,
                dataMeta,
                refGuideListTable,
                currentPage,
                totalCategories,
                perPage,
                // coverImage,
                deleteData,
                updateGuidesOrdering,
                totalGuides,
            }
        },
        methods:{
            deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm(`Please confirm that you want to delete Guide ID = ${id}`, {
                        title: 'Please Confirm',
                        size: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        cancelVariant: 'outline-secondary',
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then(value => {
                        if(value === true){
                        this.deleteData(id)
                    }
                })
            },
        }
    }
</script>

<style>
    .rating-blackground{
        background: rgba(34, 41, 47, 0);
    }
</style>